class ClipperQuantityBreaks extends HTMLElement {
  connectedCallback() {
    this.formId = this.dataset.formId;
    this.form = document.getElementById(this.formId);
    this.radios = [...this.querySelectorAll('input[type="radio"][name="quantity"]')];

    if (!this.form || this.radios.length === 0) return;

    this.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"][name="quantity"]')) {
        this.updatePurchaseSummary(event.target);
      }
    });

    this.updatePurchaseSummary(this.radios.find((radio) => radio.checked) || this.radios[0]);
  }

  updatePurchaseSummary(input) {
    const quantity = Number(input.value) || 1;
    const formattedPrice = input.dataset.formattedPrice || '';

    this.form.querySelectorAll('product-buy-price').forEach((price) => {
      price.textContent = formattedPrice;
    });

    document.querySelectorAll(`[data-clipper-sticky-price="${this.formId}"]`).forEach((price) => {
      price.textContent = formattedPrice;
    });

    const quantityLabel = quantity === 1 ? '1 bucată' : `${quantity} bucăți`;
    const accessibleLabel = `Adaugă în coș · ${formattedPrice} · ${quantityLabel}`;

    this.form.querySelectorAll(`[data-clipper-volume-submit="${this.formId}"]`).forEach((button) => {
      button.setAttribute('aria-label', accessibleLabel);
    });

    document.querySelectorAll(`[data-clipper-sticky-submit="${this.formId}"]`).forEach((button) => {
      button.setAttribute('aria-label', accessibleLabel);
    });
  }
}

if (!customElements.get('clipper-quantity-breaks')) {
  customElements.define('clipper-quantity-breaks', ClipperQuantityBreaks);
}
